<template>
  <nav class="fixed bottom-0 w-full max-w-[800px] shadow-lg px-1">
    <div class="bg-white shadow-[0_-4px_40px_0px_rgba(0,0,0,0.1)] relative pt-2 pb-1">
      <ul class="grid grid-flow-col grid-cols-5 justify-between">
        <NavLink v-for="(nav, index) in navbar" 
          :key="index" 
          :to="{ name: nav.name }" 
          :icon="nav.icon" 
          :label="nav.label" 
          :custom-class="nav.customClass" 
          :notif="nav.notif"
          :newTab="nav.newTab"
        />
      </ul>
      <div 
        class="h-1 bg-primary rounded-b-full w-[20%] absolute top-0 ease-in-out transition-all duration-500"
        :class="animatedClass" 
        :style="{ left: `calc(${currentIndex} * 20%)` }"
      ></div>
    </div>
  </nav>
</template>

<script>
import { useRoute } from 'vue-router';
import { ref, onMounted, watch, computed } from 'vue';
import NavLink from './NavLink.vue';
import { useNotificationStore } from '@/stores/useNotificationStore';

export default {
  name: 'NavBar',
  components: { NavLink },
  setup() {
    const currentIndex = ref(null);
    const animatedClass = ref('');
    const route = useRoute();

    const notificationStore = useNotificationStore();

    // Daftar menu navigasi dengan nilai notif dipastikan sebagai angka
    const navbar = computed(() => [
      { name: 'Home', icon: ['fas', 'house'], label: 'Home', notif: 0, newTab: false },
      { name: 'Publication', icon: ['fas', 'newspaper'], label: 'News', notif: 0, newTab: false },
      { name: 'QRCodeScanner', icon: ['fas', 'qrcode'], label: 'Pay', customClass: 'QR', notif: 0, newTab: false },
      { name: 'Academic', icon: ['fas', 'graduation-cap'], label: 'Edu', notif: 0, newTab: false },
      { name: 'Notification', icon: ['fas', 'envelope'], label: 'Notif', notif: notificationStore.notificationCount, newTab: false}, // Pastikan nilai angka
    ]);

    // Cek indeks halaman aktif di navbar
    const checkIndex = () => {
      currentIndex.value = navbar.value.findIndex(item => item.name === route.name);
      animatedClass.value = 'animate-wideAbit';

      setTimeout(() => {
        animatedClass.value = '';
      }, 500);
    };

    onMounted(() => {
      checkIndex();
    });

    // Pantau perubahan route
    watch(() => route.name, checkIndex);

    return {
      navbar,
      currentIndex,
      animatedClass,
    };
  },
};
</script>
